/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const GET_WP_APPLICATION = gql`
  query GetWorkPermit($credentialNo: String!) {
    getWorkPermit(credentialNo: $credentialNo) {
      terminated
      issuanceDate
      pdf
      type
      legacy
      verifyURL
      issuedTo {
        address {
          addressLine1
          addressLine2
          addressLine3
          country
          city
          parish
          state
          zipcode
        }
        alias
        childrenOrDependent
        countryConvicted
        criminalOffence
        dateOfBirth
        dateOfConviction
        dependentInfo {
          dependentType
          name
          passportNumber
          relationship
        }
        email
        firstName
        gender
        isLastNameExist
        lastEmployer {
          name
          wpExpiry
          credentialNo
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          primaryContactNo
        }
        lastName
        maritalStatus
        middleName
        nationality
        natureOfOffence
        occupation
        passportExpiry
        passportType
        passportNumber
        permissionPeriod {
          from
          to
        }
        placeOfBirth
        primaryContactNo
        qualification {
          degree
          description
          from
          institute
          to
        }
        skills
        spouseLastEmployer {
          name
          address {
            addressLine2
            addressLine1
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          wpExpiry
          credentialNo
        }
        spouseName
        trn
        vuid
        workExperience {
          jobDuty
          nameOfOrganization
          refLetter
          from
          to
        }
        workedInJamaica
      }
      employer {
        name
        dateOfRegistration
        operatingAddress {
          addressLine1
          addressLine2
          addressLine3
          city
          country
          parish
          state
          zipcode
        }
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          country
          parish
          state
          zipcode
        }
        documents {
          expiry
          fileType
          name
          src
          type
        }
        email
        natureOfBusiness
        primaryContactNo
        orgId
        saffCompsition {
          citizenship
          clerksOrServiceWorker
          elementaryOccupations
          plantAndMachineOperators
          professional
          skilledWorkers
          total
        }
        status
        tccExpiryDate
        tccNumber
        tradingName
        trn
        type
        credentialNo
        wpExpiry
      }
      credentialNo
      status
      renewalStatus
      validFrom
      validTill
      application {
        applicantInfo {
          firstName
          fullName
          lastName
          email
        }
      }
    }
  }
`;
